import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import SugargooReviewPage from "../pages/sugargoo-review/page";
import ShippingCostPage from "../pages/shipping-cost/page";
import CouponGuidePage from "../pages/coupon-guide/page";
import ShoppingGuidePage from "../pages/shopping-guide/page";
import WarehouseGuidePage from "../pages/warehouse-guide/page";
import FindsHaulPage from "../pages/finds-haul/page";
import ShoesGuidePage from "../pages/shoes-guide/page";
import HoodiesGuidePage from "../pages/hoodies-guide/page";
import AccessoriesGuidePage from "../pages/accessories-guide/page";
import BeginnerMistakesPage from "../pages/beginner-mistakes/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/what-is-sugargoo-spreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/sugargoo-review-is-sugargoo-legit",
    element: <SugargooReviewPage />,
  },
  {
    path: "/sugargoo-shipping-cost-guide",
    element: <ShippingCostPage />,
  },
  {
    path: "/sugargoo-coupon-discount-guide",
    element: <CouponGuidePage />,
  },
  {
    path: "/sugargoo-spreadsheet-shopping-guide",
    element: <ShoppingGuidePage />,
  },
  {
    path: "/sugargoo-warehouse-guide",
    element: <WarehouseGuidePage />,
  },
  {
    path: "/sugargoo-finds-haul-guide",
    element: <FindsHaulPage />,
  },
  {
    path: "/sugargoo-spreadsheet-shoes",
    element: <ShoesGuidePage />,
  },
  {
    path: "/sugargoo-spreadsheet-hoodies",
    element: <HoodiesGuidePage />,
  },
  {
    path: "/sugargoo-spreadsheet-accessories",
    element: <AccessoriesGuidePage />,
  },
  {
    path: "/sugargoo-beginner-mistakes",
    element: <BeginnerMistakesPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;